import { createRef, useState } from 'react'
import ReactSignatureCanvas from 'react-signature-canvas'

import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import Paragraph from '../app/design/Paragraph'

type Props = {
    isOpen: boolean
    isSigning?: boolean
    onClose: () => void
    onDone: (signatureData: string) => void
}

export const SignatureModal = ({ isOpen, onClose, onDone, isSigning = false }: Props) => {
    const [saveEnabled, setSaveEnabled] = useState(false)

    const padRef = createRef<ReactSignatureCanvas>()

    const onEnd = () => {
        if (!padRef.current) return

        setSaveEnabled(!padRef.current.isEmpty())
    }

    const clearSignature = () => {
        if (padRef.current) {
            padRef.current.clear()
            setSaveEnabled(false)
        }
    }

    const onSaveClicked = () => {
        if (!padRef.current) return
        padRef.current.off()

        const dataParts = padRef.current.toDataURL('image/png').split(',')
        const signatureData = dataParts.pop() as string
        onDone(signatureData)
    }

    return (
        <Modal
            title="Add signature"
            isOpen={isOpen}
            onClose={onClose}
            footer={
                <div className="flex w-full justify-between">
                    <Button intent="secondary" onClick={clearSignature}>
                        Clear
                    </Button>
                    <Button intent="primary" onClick={onSaveClicked} disabled={!saveEnabled}>
                        Save
                    </Button>
                </div>
            }
        >
            <Paragraph className="mb-6 text-gray-600">Sign in the box below</Paragraph>

            <div className="relative h-[300px] w-[680px]">
                <div className="absolute z-10 h-full w-full rounded-lg bg-gray-200">
                    <div className="absolute top-2/3 right-0 left-0 -z-10 mx-auto h-[1px] w-[calc(100%-64px)] bg-[#afafaf]" />
                </div>

                <div className="absolute top-0 z-20 h-full w-full">
                    <ReactSignatureCanvas
                        canvasProps={{ width: 680, height: 300 }}
                        onEnd={onEnd}
                        ref={padRef}
                    />
                </div>
            </div>
        </Modal>
    )
}
